export default __webpack_public_path__ + "f6724790ff2fd77c62ac665562bb4848.png";